module.exports = __webpack_public_path__ + "img/02_sub_uk.232a37f4.svg";